const WARNING_RISK_BANDS = ['6a', '6b'];

export const isWarningRiskBand = riskBandValue => WARNING_RISK_BANDS.includes(riskBandValue);
